export const effects = {
    // Tribunal, Bloodmoon
    'Damage Health': { positive: false },
    'Damage Magicka': { positive: false },
    'Blind': { positive: false },
    'Drain Alteration': { positive: false },
    'Weakness to Fire': { positive: false },

    'Resist Paralysis': { positive: true },
    
    'Recall': { positive: true },
    'Frost Damage': { positive: false },

    'Drain Agility': { positive: false },
    'Drain Endurance': { positive: false },
    'Drain Intelligence': { positive: false },
    'Drain Luck': { positive: false },
    'Drain Personality': { positive: false },
    'Drain Speed': { positive: false },
    'Drain Strength': { positive: false },
    'Drain Willpower': { positive: false },
    'Drain Fatigue': { positive: false },
    'Drain Health': { positive: false },
    'Drain Magicka': { positive: false },
    'Fortify Agility': { positive: true },
    'Fortify Endurance': { positive: true },
    'Fortify Intelligence': { positive: true },
    'Fortify Luck': { positive: true },
    'Fortify Personality': { positive: true },
    'Fortify Speed': { positive: true },
    'Fortify Strength': { positive: true },
    'Fortify Willpower': { positive: true },
    'Fortify Fatigue': { positive: true },
    'Fortify Health': { positive: true },
    'Fortify Magicka': { positive: true },
    'Restore Agility': { positive: true },
    'Restore Endurance': { positive: true },
    'Restore Intelligence': { positive: true },
    'Restore Luck': { positive: true },
    'Restore Personality': { positive: true },
    'Restore Speed': { positive: true },
    'Restore Strength': { positive: true },
    'Restore Willpower': { positive: true },
    'Restore Fatigue': { positive: true },
    'Restore Health': { positive: true },
    'Restore Magicka': { positive: true },
    'Resist Poison': { positive: true },
    'Telekinesis': { positive: true },
    'Detect Animal': { positive: true },
    'Paralyze': { positive: false },
    'Resist Magicka': { positive: true },
    'Resist Common Disease': { positive: true },
    'Detect Key': { positive: true },
    'Invisibility': { positive: true },
    'Resist Fire': { positive: true },
    'Resist Frost': { positive: true },
    'Resist Shock': { positive: true },
    'Light': { positive: true },
    'Cure Common Disease': { positive: true },
    'Cure Blight Disease': { positive: true },
    'Cure Poison': { positive: true },
    'Cure Paralyzation': { positive: true },
    'Dispel': { positive: true },
    'Levitate': { positive: true },
    'Fire Shield': { positive: true },
    'Lightning Shield': { positive: true },
    'Frost Shield': { positive: true },
    'Reflect': { positive: true },
    'Night Eye': { positive: true },
    'Spell Absorption': { positive: true },
    'Fortify Attack': { positive: true },
    'Burden': { positive: false },
    'Feather': { positive: true },
    'Detect Enchantment': { positive: true },
    'Swift Swim': { positive: true },
    'Water Walking': { positive: true },
    'Water Breathing': { positive: true },
    'Vampirism': { positive: false },
    'Damage Intelligence': { positive: false },
    'Poison': { positive: false }
}